type BrandFilter = {
  label: string
  value: string
  count: number
}

const getBrandFilters = <T extends BrandFilter>(allFilters: T[], activeFilters = []):
  (BrandFilter & { checked: boolean })[] => (
    allFilters.map(({ label, value, count }) => ({
      label,
      value,
      count,
      checked: activeFilters.includes(value),
    }))
  )


export default getBrandFilters
